// import { Select, Option } from '@material-tailwind/react';
import { Select } from 'antd';
import React, { useEffect, useState } from 'react';

export type LmsSelectOption = {
  key: string;
  value: string;
  label: string;
};

interface LmsSelectProps {
  label: string;
  options: LmsSelectOption[];
  className?: string;
  value?: string;
  notFoundContent?: string;
  clearVisible?: boolean;
}
const LmsSelect = ({
  label,
  options,
  className,
  value,
  notFoundContent = '검색 결과가 없습니다.',
  clearVisible = true,
  onChange,
}: LmsSelectProps & { onChange: (v: string) => void }) => {
  const [selected, setSelected] = React.useState<string | undefined>();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    // Cleanup when the component unmounts
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  useEffect(() => {
    handleChange(value);
  }, [value]);

  const handleChange = (value: string) => {
    setSelected(value);
    onChange(value);
  };
  return (
    <div className="flex items-center gap-2">
      <div className="flex w-16 text-sm lg:hidden">{label}</div>
      <Select
        value={value && selected}
        onChange={handleChange}
        className={className}
        placeholder={label}
        notFoundContent={notFoundContent}
        open={open}
        onDropdownVisibleChange={(visible) => setOpen(visible)}
      >
        {options.map(({ key, value, label }) => (
          <Select.Option key={key} value={value}>
            {label}
          </Select.Option>
        ))}
      </Select>
      {selected && clearVisible && (
        <div className="cursor-pointer" onClick={() => handleChange(undefined)}>
          <img src={process.env.PUBLIC_URL + '/svg/icon/x-circle.svg'} />
        </div>
      )}
    </div>
  );
};

export const LmsMultiSelect = ({
  label,
  value,
  options,
  className,
  onChange,
}: Omit<LmsSelectProps, 'value'> & {
  onChange: (v: string[]) => void;
  value?: string[];
}) => {
  return (
    <div className="flex items-center gap-2">
      <div className="flex w-16 text-sm lg:hidden">{label}</div>
      <Select
        mode="multiple"
        onChange={onChange}
        className={className}
        placeholder={label}
        value={value}
      >
        {options.map(({ key, value, label }) => (
          <Select.Option key={key} value={value}>
            {label}
          </Select.Option>
        ))}
      </Select>
    </div>
  );
};

export function toLmsSelectOptions<T>(
  items: T[],
  keyField: keyof T,
  valueField: keyof T,
  labelField: keyof T,
): LmsSelectOption[] {
  if (!items) return [];
  return items.map((item) => ({
    key: String(item[keyField]),
    value: String(item[valueField]),
    label: String(item[labelField]),
  }));
}

export default LmsSelect;
